import { Box, Button, Grid, Heading, Tag } from '@chakra-ui/react';

import Tip from '@/components/Tip/Tip';
import IEventType from '@/types/IEventType';
import { FiUsers } from 'react-icons/fi';
import AddGroupModal from './components/add-group-modal/add-group.modal';
import { Group } from './components/group/group.view';
import { useRoundRobinParticipants } from './round-robin-participants.controller';

interface IProps {
	eventType: IEventType;
	onChange: (change: Partial<IEventType>) => void;
}

export default function RoundRobinParticipants(props: IProps) {
	const { query, t, handleRemoveGroup, disclosure, isLoading, hasGroups } = useRoundRobinParticipants(props);

	if (!query.data?.resourceGroups) {
		return null;
	}

	return (
		<Box>
			<Grid gridTemplateColumns="1fr auto" alignItems="center">
				<Heading size="sm">{t('Groups')}</Heading>
				<Tag colorScheme="orange">Beta</Tag>
			</Grid>

			{!hasGroups ? (
				<Box my={4}>
					<Tip>
						{t(
							'Create availability groups and add them. The booking calendar will show available slots when AT LEAST ONE person in the group is available.'
						)}
					</Tip>
				</Box>
			) : (
				<Box my={4}>
					{props.eventType.resourceRules?.availableInGroups?.map((rg) => {
						const group = query.data?.resourceGroups.find((g) => g.id === rg.group.id);
						if (!group) {
							return null;
						}
						return (
							<Group
								key={group.id}
								resourceGroup={group}
								min={rg.min}
								onRemoveClick={() => {
									handleRemoveGroup(group.id);
								}}
							/>
						);
					})}
				</Box>
			)}

			<Button
				isLoading={isLoading}
				aria-label="Add group"
				colorScheme="primary"
				onClick={disclosure.onOpen}
				rightIcon={<FiUsers />}
				size="sm"
				w="full"
			>
				{t('Add group')}
			</Button>

			<AddGroupModal
				eventType={props.eventType}
				isOpen={disclosure.isOpen}
				close={disclosure.onClose}
				resourceGroups={query.data.resourceGroups}
			/>
		</Box>
	);
}
